import * as React from 'react';
import clsx from 'clsx';
import { NotificationButton } from '@/components/common/NotificationButton';

interface PageHeaderProps {
  title: string;
  titleClassName?: string;
  /**
   * Controls the desktop icon color set.
   * 'light' = White icons (Home)
   * 'dark' = Black icons (Account)
   */
  theme?: 'light' | 'dark';
  children?: React.ReactNode;
  showNotifications?: boolean;
}

/**
 * PageHeader Component
 *
 * Updates:
 * - Added `theme` prop to toggle Desktop Bell color.
 * - Render only Title and Desktop Bell (Mobile controls are in MainLayout).
 * - Added border color logic for the notification badge ring.
 */
export const PageHeader: React.FC<PageHeaderProps> = ({
  title,
  titleClassName,
  theme = 'light',
  children,
  showNotifications = true,
}) => (
  <div className='mb-1 flex w-full shrink-0 flex-col gap-4 md:mb-4 md:flex-row md:items-center md:justify-between'>
    {/* Title */}
    <h1
      className={clsx(
        'whitespace-nowrap font-proxima font-extrabold uppercase tracking-normal',
        'text-left text-24 leading-47',
        'md:text-left md:text-40 md:leading-47',
        titleClassName
      )}
    >
      {title}
    </h1>

    {/* Controls Container */}
    <div className='flex items-center gap-4'>
      {children && <div className='hidden xl:block'>{children}</div>}
      {showNotifications && (
        <div className='hidden xl:block'>
          <NotificationButton theme={theme} />
        </div>
      )}
    </div>
  </div>
);
